import {
  POPULATE_WORKSPACES,
  SET_PENDING_WORKSPACE_INVITES,
  TOGGLE_SELECT_WORKSPACE_MODAL,
  UPDATE_UNSEEN_NOTIFICATIONS,
  UPDATE_WORKSPACE_ADMINS,
  UPDATE_WORKSPACE_DETAILS,
} from '../constants/actions';

export const populateWorkspaces = workspaces => {
  return {
    type: POPULATE_WORKSPACES,
    workspaces,
  };
};

export const updateWorkspaceDetails = workspace => {
  return {
    type: UPDATE_WORKSPACE_DETAILS,
    workspace,
  };
};

export const toggleSelectWorkspaceModal = showModal => {
  return {
    type: TOGGLE_SELECT_WORKSPACE_MODAL,
    showModal,
  };
};

export const setPendingInvites = pendingInvites => {
  return {
    type: SET_PENDING_WORKSPACE_INVITES,
    pendingInvites,
  };
};

export const updateWorkspaceAdmins = (id, admins) => {
  return {
    type: UPDATE_WORKSPACE_ADMINS,
    id,
    admins,
  };
};

export const updateUnseenNotifications = (id, count) => {
  return {
    type: UPDATE_UNSEEN_NOTIFICATIONS,
    id,
    count,
  };
};
